import { Flex } from "antd";
import LabelGap from "../LabelGap";

import StyledCard from "./style";

const CardStatisticSecondary = ({ gap, value, title }) => (
  <StyledCard className="card-statistic-secondary-container">
    <Flex align="center" justify="space-between">
      <h4>{value}</h4>
      <LabelGap gap={gap} />
    </Flex>

    {title}
  </StyledCard>
);

export default CardStatisticSecondary;
